import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./plugins/element";
import "./assets/css/common.css";
import "./assets/css/circle.css";
import "./assets/js/rem.js";
import "./assets/js/circle";
// import "animate.css";
import "wowjs/css/libs/animate.css";
import { WOW } from "wowjs";
import "./assets/icon/iconfont.css";

import "jquery";
import "@/services/router-permission";
import http from "./services/http/http";
import uitls from "./utils/index";
import constants from "@/api/constants"; // api 接口集合
Vue.use(http);
Vue.use(uitls);
Vue.use(constants);

Vue.prototype.WOW = WOW;

Vue.use(ElementUI); //使用elementUI
Vue.config.productionTip = false;

// 非开发环境去掉console
if (process.env.NODE_ENV !== 'development') { // process是Node环境全部变量, 运行时根据敲击的命令不同, 脚手架会取环境变量给env添加属性和值
  console.log = function () {}
  console.error = function(){}
  console.dir = function(){}
}

const _this = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default _this;